module.exports = __webpack_public_path__ + "9dc203b81e2f76d80b05e4d06e680ce4.png";